import { render, staticRenderFns } from "./Shortlist.vue?vue&type=template&id=580d7838&scoped=true&"
import script from "./Shortlist.vue?vue&type=script&lang=js&"
export * from "./Shortlist.vue?vue&type=script&lang=js&"
import style0 from "./Shortlist.vue?vue&type=style&index=0&id=580d7838&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580d7838",
  null
  
)

export default component.exports